/**
 * Original placeholder marks for hero tiles.
 *
 * Keyed by catalog slug. These are our own simplified geometric marks — they
 * stand in for a tile that has no uploaded `logo`, and are automatically
 * replaced the moment a real logo is set on the CatalogApp row.
 */

type Mark = { bg: string; fg: string; path: string };

export const TILE_MARKS: Record<string, Mark> = {
  accounts: {
    bg: '#eef2ff',
    fg: '#4f46e5',
    path: 'M17 20v-1.5A3.5 3.5 0 0 0 13.5 15h-5A3.5 3.5 0 0 0 5 18.5V20M11 11.5a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M18.5 15.5h2v4h-2',
  },
  'app-store': {
    bg: '#e8f0ff',
    fg: '#1452ff',
    path: 'M11 19.5v-15M11 4.5l4.5 8M11 4.5 6.5 12.5M6.5 12.5 4 17.5h5M6.5 12.5 9 17.5M15.5 12.5 18 17.5h-5M15.5 12.5 13 17.5M11 19.5h5',
  },
  boosting: {
    bg: '#fff3ec',
    fg: '#fe4b00',
    path: 'M13.5 3.5 6 13h5l-1.5 7.5L18 11h-5l1.5-7.5Z',
  },
  'brawl-stars': {
    bg: '#fff8e6',
    fg: '#f5a623',
    path: 'M12 3.5l2.4 4.2 4.8 1-3.3 3.6.5 4.9L12 15.4 7.6 17.2l.5-4.9L4.8 8.7l4.8-1L12 3.5Z',
  },
  'clash-of-clans': {
    bg: '#eefaf0',
    fg: '#22a35b',
    path: 'M5 19v-7l3-2 4 2 4-2 3 2v7H5ZM8 12V8l4-3 4 3v4M12 9v10',
  },
  'pubg-mobile': {
    bg: '#fff1e2',
    fg: '#f08a24',
    path: 'M11 4.5h5a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-2v3l-3.5-3H8a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3M11.5 9.5v5M9 12h5',
  },
  roblox: {
    bg: '#f4f4f5',
    fg: '#3f3f46',
    path: 'M7 6.5 18 8l-1 9.5L6 16l1-9.5ZM10 10.5l4 .6M9.7 13l4 .6',
  },
  fortnite: {
    bg: '#eef2ff',
    fg: '#4f46e5',
    path: 'M11 5.5c0 1 .8 1.8 1.8 1.8h2.7M11 5.5a1.8 1.8 0 0 0-1.8 1.8V9M11 5.5c0 2.5-1.2 3.2-2.4 4.4a5.5 5.5 0 0 0-1.1 5M15.5 7.3c1.2.9 1.5 2.1 1.5 3.4M18.5 15.5c0 2-1.6 3.5-3.5 3.5H9a3.5 3.5 0 0 1-3.5-3.5c0-2 1.6-3.5 3.5-3.5h4',
  },
  'genshin-impact': {
    bg: '#f0f7ff',
    fg: '#3b82c4',
    path: 'M12 3.5l2.3 5.2 5.2 2.3-5.2 2.3L12 18.5l-2.3-5.2L4.5 11l5.2-2.3L12 3.5ZM12 9.2 10.4 12 12 14.8 13.6 12 12 9.2Z',
  },
  'standoff-2': {
    bg: '#fdf2e9',
    fg: '#d97706',
    path: 'M13.5 4.5H9A3 3 0 0 0 6 7.5v7a3 3 0 0 0 3 3h1.5M15.5 8.5h2a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-2M8 11h5M8 14h3',
  },
  chatgpt: {
    bg: '#ecfdf5',
    fg: '#0d9488',
    path: 'M11 4.2 6.4 13h4l-1.6 3.6 4.8-9h-4l1.4-3.4Z',
  },
  claude: {
    bg: '#fff1ed',
    fg: '#d97757',
    path: 'M8.5 14.5 12 17.5l3.5-3-1-3.5h-4.5l-1.5 3.5ZM11 5l1 6h4.5',
  },
  apple: {
    bg: '#f5f5f7',
    fg: '#1d1d1f',
    path: 'M14.8 7.2c.9-1.1.8-2.7.7-3.2-1 .1-2.2.7-3 1.7-.7.9-1 2-.9 3.1 1.1.1 2.2-.6 3.2-1.6ZM16.5 12.2c0-2 1.6-3 1.7-3.1-1-.9-2.2-1-2.7-1-1.2-.1-2.2.7-2.8.7-.6 0-1.5-.7-2.5-.7-1.3 0-2.5.8-3.2 1.9-1.3 2.3-.4 5.7 1 7.6.6.9 1.4 1.9 2.4 1.9 1-.1 1.4-.6 2.6-.6 1.2 0 1.5.6 2.6.6 1.1 0 1.7-1 2.3-1.9.7-1 1-2.2 1-2.3-.1 0-1.9-.7-2-2.1Z',
  },
  telegram: {
    bg: '#e8f4fd',
    fg: '#229ed9',
    path: 'M18 6 9.6 14.4M6.5 13.2 4.8 17.3c-.2.5.2 1 .7.8l3-1.2 8.9 4.3c.7.3 1.4-.3 1.5-1l1.4-10.8c.1-.8-.6-1.4-1.3-1.2L18 6Z',
  },
  playstation: {
    bg: '#f0f5ff',
    fg: '#003791',
    path: 'M10 6.5v9.8l7.2 2.2V8.6M10 6.5 5 7.8v7.9l5-1.3M17 8.6l-7-2.1v4.2',
  },
  steam: {
    bg: '#eaf4f9',
    fg: '#1b2838',
    path: 'M11.6 5.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM8.6 12.7a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2ZM14.2 8.4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z',
  },
  tiktok: {
    bg: '#f2f2f4',
    fg: '#111113',
    path: 'M12 8.5c0-1.4 1-2.5 2.4-2.5V4.2c-1.5 0-2.9 1-3.5 2.4-.4 1-.9 1.4-2.4 1.4v1.8c1 0 1.9-.2 2.7-.7v4.6a3.7 3.7 0 1 1-3.7-3.7c.3 0 .6 0 .9.1v2c-.3-.1-.6-.2-.9-.2a1.8 1.8 0 1 0 1.5 1.8V8.5Z',
  },
};

/** Deterministic fallback tint for slugs with no entry above. */
function fallbackMark(slug: string): Mark {
  let hash = 0;
  for (let i = 0; i < slug.length; i += 1) hash = (hash * 31 + slug.charCodeAt(i)) % 360;
  return {
    bg: `hsl(${hash} 72% 95%)`,
    fg: `hsl(${hash} 58% 42%)`,
    path: 'M12 4.5 19 9v6l-7 4.5L5 15V9l7-4.5ZM12 9 8 11.5v5L12 19l4-2.5v-5L12 9Z',
  };
}

export function getTileMark(slug: string): Mark {
  return TILE_MARKS[slug] ?? fallbackMark(slug);
}

interface TileMarkProps {
  slug: string;
  className?: string;
}

/**
 * Renders an original mark for a tile. Sits behind `logo` — when an uploaded
 * logo exists it covers this entirely, so no migration is needed.
 */
export function TileMark({ slug, className }: TileMarkProps) {
  const mark = getTileMark(slug);
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      aria-hidden="true"
      focusable="false"
      style={{ backgroundColor: mark.bg }}
    >
      <path
        d={mark.path}
        fill="none"
        stroke={mark.fg}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}